// extracted by mini-css-extract-plugin
export default {"cls1":"RelatedPapers-cls1__wX","cls2":"RelatedPapers-cls2_r1z RelatedPapers-cls1__wX"};